const audiences = {
  gender: [
    {
      name: 'All',
      genders: [1, 2]
    },
    {
      name: 'Men',
      genders: [1]
    },
    {
      name: 'Women',
      genders: [2]
    }
  ],
  age: [
    {
      name: 'All',
      age_min: 18,
      age_max: 65
    },
    {
      name: 'Gen Z (13-17)',
      age_min: 13,
      age_max: 17
    },
    {
      name: 'College age (18-24)',
      age_min: 18,
      age_max: 24
    },
    {
      name: 'Twenties (25-34)',
      age_min: 25,
      age_max: 34
    },
    {
      name: 'Thirties (35-44)',
      age_min: 35,
      age_max: 44
    },
    {
      name: 'Gen X (45-54)',
      age_min: 45,
      age_max: 54
    },
    {
      name: 'Boomers (55-64)',
      age_min: 55,
      age_max: 64
    },
    {
      name: 'Seniors (65+)',
      age_min: 65
    }
  ],
  // ethnicity: [
  //   {
  //     name: 'All',
  //     behaviors: [
  //       {
  //         id: '6018745176183'
  //       },
  //       {
  //         id: '6021722613183'
  //       },
  //       {
  //         id: '6003133212372'
  //       }
  //     ]
  //   },
  //   {
  //     name: 'White or other',
  //     behaviors: []
  //   },
  //   {
  //     name: 'African american',
  //     behaviors: [
  //       {
  //         id: '6018745176183'
  //       }
  //     ]
  //   },
  //   {
  //     name: 'Asian american',
  //     behaviors: [
  //       {
  //         id: '6021722613183'
  //       }
  //     ]
  //   },
  //   {
  //     name: 'Hispanic',
  //     behaviors: [
  //       {
  //         id: '6003133212372'
  //       }
  //     ]
  //   }
  // ],
  politics: [
    {
      name: 'All',
      politics: [
        {
          id: '6015759997983'
        },
        {
          id: '6015760027783'
        },
        {
          id: '6031978535383'
        },
        {
          id: '6015760036783'
        },
        {
          id: '6031978554983'
        },
        {
          id: '6015760532183'
        },
        {
          id: '6029977111383'
        }
      ]
    },
    {
      name: 'Very liberal',
      politics: [
        {
          id: '6015759997983'
        }
      ]
    },
    {
      name: 'Liberal',
      politics: [
        {
          id: '6015760027783'
        },
        {
          id: '6031978535383'
        }
      ]
    },
    {
      name: 'Moderate',
      politics: [
        {
          id: '6015760036783'
        },
        {
          id: '6031978554983'
        }
      ]
    },
    {
      name: 'Conservative',
      politics: [
        {
          id: '6015760532183'
        },
        {
          id: '6029977111383'
        }
      ]
    }
  ],
  interests: [
    {
      name: 'All',
      interests: [
        {
          id: '6003422719241'
        },
        {
          id: '6003049202156'
        },
        {
          id: '6003970975896'
        }
      ]
    },
    {
      name: 'Charity and Causes',
      interests: [
        {
          id: '6003422719241'
        }
      ]
    },
    {
      name: 'Community',
      interests: [
        {
          id: '6003049202156'
        }
      ]
    },
    {
      name: 'Environmentalism',
      interests: [
        {
          id: '6003970975896'
        }
      ]
    }
  ],
  occupation: [
    {
      name: 'All',
      family_statuses: [
        {
          id: '6002714398372'
        }
      ],
      industries: [
        {
          id: '6016671857383'
        }
      ]
    },
    {
      name: 'Parents',
      family_statuses: [
        {
          id: '6002714398372'
        }
      ]
    },
    {
      name: 'Veterans',
      industries: [
        {
          id: '6016671857383'
        }
      ]
    }
  ]
}

export default audiences
